import React, { createContext, useContext, useState, useCallback } from 'react';
import {
    fetchBusinessYearlyEarnings,
    fetchBusinessMonthlyEarnings,
    fetchBusinessWeeklyEarnings,
    fetchBusinessDailyEarnings,
    fetchBusinessTodaySummary,
    fetchStaffYearlyEarnings,
    fetchStaffMonthlyEarnings,
    fetchStaffWeeklyEarnings,
    fetchStaffDailyEarnings,
    fetchStaffTodaySummary
} from '../lib/apiClientCalculateMoney';

const CalculateMoneyContext = createContext();

export const useCalculateMoneyContext = () => useContext(CalculateMoneyContext);

export const CalculateMoneyProvider = ({ children }) => {
    const [businessEarnings, setBusinessEarnings] = useState([]);
    const [staffEarnings, setStaffEarnings] = useState([]);
    const [businessTodaySummary, setBusinessTodaySummary] = useState(null);
    const [staffTodaySummary, setStaffTodaySummary] = useState(null);
    const [businessDailyEarnings, setBusinessDailyEarnings] = useState(null);
    const [staffDailyEarnings, setStaffDailyEarnings] = useState(null);

    // === BUSINESS ===
    const getBusinessYearlyEarnings = useCallback(async (businessId, yearsBack = 5) => {
        try {
            const data = await fetchBusinessYearlyEarnings(businessId, yearsBack);
            setBusinessEarnings(data);
        } catch (error) {
        }
    }, []);

    const getBusinessMonthlyEarnings = useCallback(async (businessId, year) => {
        try {
            const data = await fetchBusinessMonthlyEarnings(businessId, year);
            const earningsArray = data?.$values || data || [];
            setBusinessEarnings(earningsArray);
        } catch (error) {
        }
    }, []);

    const getBusinessWeeklyEarnings = useCallback(async (businessId, year, week) => {
        try {
            const data = await fetchBusinessWeeklyEarnings(businessId, year, week);
            setBusinessEarnings(data);
        } catch (error) {
        }
    }, []);

    const getBusinessDailyEarnings = useCallback(async (businessId, date) => {
        try {
            const data = await fetchBusinessDailyEarnings(businessId, date);
            setBusinessDailyEarnings(data);
        } catch (error) {
        }
    }, []);

    // === STAFF ===
    const getStaffYearlyEarnings = useCallback(async (businessId, staffId, yearsBack = 5) => {
        try {
            const data = await fetchStaffYearlyEarnings(businessId, staffId, yearsBack);
            setStaffEarnings(data);
        } catch (error) {
        }
    }, []);

    const getStaffMonthlyEarnings = useCallback(async (businessId, staffId, year) => {
        try {
            const data = await fetchStaffMonthlyEarnings(businessId, staffId, year);
            setStaffEarnings(data);
        } catch (error) {
        }
    }, []);

    const getStaffWeeklyEarnings = useCallback(async (businessId, staffId, year, week) => {
        try {
            const data = await fetchStaffWeeklyEarnings(businessId, staffId, year, week);
            setStaffEarnings(data);
        } catch (error) {
        }
    }, []);

    const getStaffDailyEarnings = useCallback(async (businessId, staffId, date) => {
        try {
            const data = await fetchStaffDailyEarnings(businessId, staffId, date);
            setStaffDailyEarnings(data); 
        } catch (error) {
        }
    }, []);

    const getBusinessTodaySummary = useCallback(async (businessId) => {
        try {
            const data = await fetchBusinessTodaySummary(businessId);
            setBusinessTodaySummary(data);
        } catch (error) {
        }
    }, []);

    const getStaffTodaySummary = useCallback(async (businessId, staffId) => {
        try {
            const data = await fetchStaffTodaySummary(businessId, staffId);
            setStaffTodaySummary(data);
        } catch (error) {
        }
    }, []);

    const contextValue = {
        businessEarnings,
        staffEarnings,
        businessTodaySummary,
        staffTodaySummary,
        staffDailyEarnings,
        businessDailyEarnings,
        getBusinessYearlyEarnings,
        getBusinessMonthlyEarnings,
        getBusinessWeeklyEarnings,
        getBusinessDailyEarnings,
        getBusinessTodaySummary,
        getStaffYearlyEarnings,
        getStaffMonthlyEarnings,
        getStaffWeeklyEarnings,
        getStaffDailyEarnings,
        getStaffTodaySummary,
    };

    return (
        <CalculateMoneyContext.Provider value={contextValue}>
            {children}
        </CalculateMoneyContext.Provider>
    );
};